import {RemotePaging} from "_types/table";
import {useObservable} from "@legendapp/state/react";

export function useRemotePaging(perPage: number = 10) {
    return useObservable<RemotePaging>({
        pageSize: perPage,
        pageIndex: 1,
        totalPages: 0,
        totalCount: 0,
    });
}
